import request from '@/utils/request'

// 查询节假日列表
export function listHoliday(query) {
  return request({
    url: '/system/holiday/list',
    method: 'get',
    params: query,
  })
}

// 查询节假日分页
export function pageHoliday(query) {
  return request({
    url: '/system/holiday/page',
    method: 'get',
    params: query,
  })
}

// 查询节假日详细
export function getHoliday(data) {
  return request({
    url: '/system/holiday/detail',
    method: 'get',
    params: data,
  })
}

// 新增节假日
export function addHoliday(data) {
  return request({
    url: '/system/holiday/add',
    method: 'post',
    data: data,
  })
}

// 修改节假日
export function updateHoliday(data) {
  return request({
    url: '/system/holiday/edit',
    method: 'post',
    data: data,
  })
}

// 删除节假日
export function delHoliday(data) {
  return request({
    url: '/system/holiday/delete',
    method: 'post',
    data: data,
  })
}
